<template>
  <div class="bg-truegray-700 w-full min-h-screen">
    <!-- Heading -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-gray-200">
      <div
        class="h-32 border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1 class="w-full text-left">Mail</h1>
        <span class="text-md w-full text-left"
          >Manage your newsletter and subscribers.</span
        >
      </div>
    </div>
    <!-- /Heading -->

    <!-- Content -->
    <div class="flex flex-col px-6 py-2 w-full">
      <div class="flex flex-row justify-between">
        <!--
          <ul class="flex flex-row mb-0 list-none flex-wrap pt-3 pb-4">
          <li v-for="tab in tabs" :key="tab.id">
          <button
          class="tab px-5 py-3 text-white border-white"
          :class="{
          'border-0': !isTabActive(tab.id),
          'border-b-2': isTabActive(tab.id),
          'opacity-25 cursor-not-allowed': tab.disabled
          }"
          :disabled="tab.disabled"
          @click="toggleTabs(tab.id)"
          >
          {{ tab.text }}
          </button>
          </li>
          </ul> 
        -->
        <!--
          <button class="btn btn-primary m-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          <span>New</span>
          </button> 
        -->
      </div>
      <div class="w-full flex justify-start py-6 lg:py-12">
        <div
          :style="{ height: 'max-content' }"
          class="w-16 rounded-l-xl overflow-hidden border-r flex-shrink-0"
        >
          <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="[
              'flex items-center justify-center border-t bg-white text-black hover:text-primary h-16 transform transition-all',
              tab.disabled()
                ? 'opacity-25 cursor-not-allowed'
                : 'cursor-pointer',
              {
                'border-0': !isTabActive(tab.id),
                'text-primary': isTabActive(tab.id),
              },
            ]"
            :disabled="tab.disabled()"
            @click="toggleTabs(tab.id, tab.disabled())"
          >
            <span
              :class="!isTabActive(tab.id) ? 'opacity-50' : 'scale-125'"
              class="transition-all transform"
              v-html="tab.svg"
            ></span>
          </div>
        </div>
        <!-- <keep-alive> -->
        <component :is="activeTab.component" @set-loaded-data="setLoadedData" />
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TabNewsletter from './TabNewsletter.vue'
import Subscribers from './Subscribers.vue'

export default {
  components: {
    TabNewsletter,
    Subscribers,
  },

  data() {
    return {
      loadedData: false,
      tabs: [
        {
          id: 1,
          text: 'Subscribers',
          disabled: () => false,
          component: 'Subscribers',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path d="M10 9a3 3 0 100-6 3 3 0 000 6zM6 8a2 2 0 11-4 0 2 2 0 014 0zM1.49 15.326a.78.78 0 01-.358-.442 3 3 0 014.308-3.516 6.484 6.484 0 00-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 01-2.07-.655zM16.44 15.98a4.97 4.97 0 002.07-.654.78.78 0 00.357-.442 3 3 0 00-4.308-3.517 6.484 6.484 0 011.907 3.96 2.32 2.32 0 01-.026.654zM18 8a2 2 0 11-4 0 2 2 0 014 0zM5.304 16.19a.844.844 0 01-.277-.71 5 5 0 019.947 0 .843.843 0 01-.277.71A6.975 6.975 0 0110 18a6.974 6.974 0 01-4.696-1.81z" /></svg>`,
        },
        {
          id: 0,
          text: 'Newsletter',
          disabled: () => !this.loadedData,
          component: 'TabNewsletter',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z" /><path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z" /></svg>`,
        },
      ],

      activeTabId: 1,
    }
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),

    activeTab() {
      return this.tabs.find((tab) => tab.id === this.activeTabId)
    },
  },

  async mounted() {
    this.dispatchRedirectForUpdates(
      await this.dispatchRedirectForUpdates({
        router: this.$router,
        updatesRequired: ['Mail'],
      }),
    )
  },

  methods: {
    ...mapActions({
      dispatchRedirectForUpdates: 'careerwise/dispatchRedirectForUpdates',
    }),

    toggleTabs: function (tabId, disabled) {
      if (!disabled) {
        this.activeTabId = tabId
      }
    },

    isTabActive(tabId) {
      return this.activeTabId === tabId
    },

    setLoadedData(val) {
      this.$set(this, 'loadedData', val)
    },
  },
}
</script>
